/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Observable} from 'rxjs';
import {Select, Store} from '@ngxs/store';
import {first, map, tap} from 'rxjs/operators';

import {SearchService} from '../services/search.service';
import {CancelChooseSearch, ChooseSearch} from '../state/search.actions';
import {SearchState} from '../state/search.state';
import {LoggerService} from '../../shared/services/logger.service';
import {SearchListEntry} from '../state/search.model';

@Component({
    selector: 'dash-gis-choose-search',
    templateUrl: './choose-search-dialog.component.html',
    styleUrls: [ './choose-search-dialog.component.scss' ],
})
export class ChooseSearchDialogComponent implements OnInit {

    @Select(SearchState.searches) public searches$: Observable<SearchListEntry[]>;
    @Select(SearchState.currentSearch) public currentSearch$: Observable<SearchListEntry>;

    constructor(
        private logger: LoggerService,
        private matDialogRef: MatDialogRef<ChooseSearchDialogComponent>,
        private searchService: SearchService,
        private store: Store,
        @Inject(MAT_DIALOG_DATA) private data: any,
    ) {}

    ngOnInit() {}

    public choose(searchName: string) {
        this.searches$.pipe(
            first(),
            map((searches) => searches.find(s => s.name === searchName)),
            tap((searchDef) => this.store.dispatch(new ChooseSearch({
                id: this.data.id,
                search: searchDef,
                reset: this.data.reset,
            }))),
        ).subscribe(() => this.matDialogRef.close(true));
    }

    public cancel() {
        this.store.dispatch(new CancelChooseSearch()).subscribe(() => this.matDialogRef.close(false));
    }
}
